import BaseService from '@/ecm/common/BaseService.js';

class DefFieldService {
  baseUrl = 'def-field';
  checkIfDefFieldHasPerformanceQuery = (defFieldId) => BaseService.get({ url: `${this.baseUrl}/check-if-deffield-has-performance-query/${defFieldId}` });
  validateBidirectionalRelation = (data) => BaseService.post({ url: `${this.baseUrl}/validate-bidirectional-relations`, data });
}

export default new DefFieldService();
